import { useTheme } from '../lib/theme.ts';
import { Icon } from './icons.tsx';

/**
 * Light / dark switch. `icon`: a square button (sun in dark, moon in light); `row`: a full-width
 * menu row with its name. `labels` lets the phone app pass its translated words.
 */
export function ThemeToggle({
  variant = 'icon',
  className = '',
  labels = { dark: 'Dark mode', light: 'Light mode' },
}: {
  variant?: 'icon' | 'row';
  className?: string;
  labels?: { dark: string; light: string };
}) {
  const [theme, setTheme] = useTheme();
  const next = theme === 'dark' ? 'light' : 'dark';
  const name = next === 'dark' ? labels.dark : labels.light;
  if (variant === 'row') {
    return (
      <button
        type="button"
        onClick={() => setTheme(next)}
        className={`flex h-13 w-full items-center gap-3 rounded-xl px-3.5 text-base font-semibold hover:bg-ground focus-visible:outline-3 focus-visible:outline-ink ${className}`}
      >
        <Icon name={next === 'dark' ? 'moon' : 'sun'} size={20} />
        {name}
      </button>
    );
  }
  return (
    <button
      type="button"
      onClick={() => setTheme(next)}
      aria-label={name}
      title={name}
      className={`flex shrink-0 items-center justify-center rounded-lg text-muted hover:bg-ground hover:text-ink focus-visible:outline-3 focus-visible:outline-ink ${className}`}
    >
      <Icon name={next === 'dark' ? 'moon' : 'sun'} size={18} />
    </button>
  );
}
